import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import api from "../../../services/api";

const TechpackDetails = () => {
  const params = useParams();
  const [techpack, setTechpack] = useState({});

  const getTechpack = async () => {
    try {
      const response = await api.post("/techpacks-show", { id: params.id });
      if (response.status === 200 && response.data) {
        setTechpack(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching techpack data:", error);
    }
  };

  useEffect(() => {
    getTechpack();
  }, []);

  const handlePrint = () => {
    window.print();
  };

  if (!techpack) {
    return <div>No techpack data available.</div>;
  }

  return (
    <div className="create_edit_page">
      <div className="create_page_heading">
        <div className="page_name">Techpacks </div>
        <div className="actions">
          <Link
            to="/merchandising/techpacks"
            className="btn btn-danger  rounded-circle"
          >
            <i className="fal fa-times"></i>
          </Link>
        </div>
      </div>

      <table className="table table-bordered">
        <tbody>
          {/* First row with the headers */}
          <tr>
            <td>Buyer</td>
            <td>Style/Index</td>
            <td>Season</td>
            <td>Item Type</td>
          </tr>
          {/* Second row with values */}
          <tr>
            <td>{techpack.buyer}</td>
            <td>{techpack.title}</td>
            <td>{techpack.season}</td>
            <td>{techpack.item_type}</td>
          </tr>

          {/* Row with item details */}
          <tr>
            <td>Item Name</td>
            <td>Sizes</td>
            <td>Wash Details</td>
            <td>Special Operations</td>
          </tr>
          <tr>
            <td>{techpack.item_name}</td>
            <td>
              {techpack.sizeList?.length > 0 &&
                techpack.sizeList?.map((item, index) => (
                  <span
                    className="btn btn-outline-success btn-sm me-1"
                    key={index}
                  >
                    {item.title}
                  </span>
                ))}
            </td>
            <td>{techpack.wash_details}</td>
            <td>{techpack.operations}</td>
          </tr>

          {/* FDS Details section */}
          <tr>
            <td className="text-center" colSpan={4}>
              FDS DETAILS
            </td>
          </tr>
          <tr>
            <td>Shrinkage</td>
            <td>GSM</td>
            <td>Width</td>
            <td>Composition</td>
          </tr>
          <tr>
            <td>
              Length: {techpack.fds_shrinkage_length}, Width:{" "}
              {techpack.fds_shrinkage_width}
            </td>
            <td>{techpack.fds_gsm}</td>
            <td>{techpack.fds_width}</td>
            <td>{techpack.fds_composition}</td>
          </tr>

          {/* Image section */}
          <tr>
            <td className="text-center" colSpan={2}>
              <img
                style={{
                  margin: "0 auto",
                  width: "300px",
                }}
                src={techpack.file_source}
                alt="Techpack"
                className="techpack-img"
              />
            </td>
            <td colSpan={2}>
              <div className="attachments">
                <strong>Techpack, Spec Sheet, Block Pattern: </strong>
                <br />
                <a
                  target="_blank"
                  className="btn btn-sm me-2 btn-outline-success"
                  href={techpack.techpack_file_url}
                >
                  {techpack.techpack_file}
                </a>

                <a
                  target="_blank"
                  className="btn btn-sm me-2 btn-outline-success"
                  href={techpack.specsheet_url}
                >
                  {techpack.specsheet}
                </a>

                <a
                  target="_blank"
                  className="btn btn-sm me-2 btn-outline-success"
                  href={techpack.block_pattern_url}
                >
                  {techpack.block_pattern}
                </a>

                <div>
                  <strong>Others:</strong>
                  <br />
                  {techpack.attatchments &&
                    techpack.attatchments.map((file, index) => (
                      <a
                        key={index}
                        target="_blank"
                        className="btn btn-sm me-2 btn-outline-success"
                        href={file.file_source}
                      >
                        {file.filename}
                      </a>
                    ))}
                </div>
              </div>
            </td>
          </tr>

          {/* Description section */}
          <tr>
            <td colSpan="4">{techpack.description}</td>
          </tr>
        </tbody>
      </table>

      <br />

      <div className="footer">
        <div className="submit-area">
          <Link to="/merchandising/techpacks" className="btn btn-danger">
            GO BACK
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TechpackDetails;
